<template>
    <div>
        <self-back :pageHeaderList="[{'name':'项目列表'}]"></self-back>
        <div class="containter" v-loading = 'loading'>
            <div class="topOperation clear">
                <div class="left">
                    <button @click="isNewProject=1;projectFlag=true;operationProject={}">新建</button>
                    <!-- <button @click="getListEvent(1,'export')">导出</button> -->
                    <button @click="deleteProject">删除</button>
                </div>
                <div class="right">
                    <el-input placeholder="请输入项目名称" v-model.trim="keyword" clearable  @keydown.enter.native="keyword?getListEvent(1):''" @clear="getListEvent(1)" size="mini" style="width:200px">
                        <el-button slot="append" icon="el-icon-search" @click="keyword?getListEvent(1):''" style="padding:0 10px"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="listBox">
                <el-table
                    :max-height="tableMaxHeight"
                    ref="multipleTable"
                    border
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" :selectable='checkSelectable'></el-table-column>
                    <el-table-column label="项目名称" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.title }}</template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="创建时间" align="center"></el-table-column>
                    <el-table-column label="操作" width="350" align="center">
                        <!-- <template slot-scope="scope">
                            <div class="projectItemOperation" @click.stop="toFileAdmin(scope.row.id)">文档管理</div>
                        </template> -->
                    </el-table-column>
                </el-table>
                <div class="paginationBox" style="height: 30px;">
                    <el-pagination
                       small
                        background
                        :current-page="page"
                        :page-size="page_size"
                        @current-change="handleCurrentChange"
                        layout="total, prev, pager, next, jumper"
                        :total="total" />
                </div>
            </div>
        </div>
        <!-- 添加、修改项目 -->
        <el-dialog :title="isNewProject==1?'新建项目':'修改项目'" top="7vh" :visible.sync="projectFlag" :close-on-click-modal='false'>
            <add-project @rmit_updateList="rmit_updateList" @emit_closeToast='emit_closeToast' :operationProject="operationProject"></add-project>
        </el-dialog>
    </div>
</template>
<script>
import addProject from './addNewProject'
export default {
    components:{
        addProject,
    },
    data(){
        return{
            page:1,
            page_size:20,
            total:0,
            loading:false,
            timeMonth:'',
            keyword:'',
            tableData: [],
            multipleSelection:[],
            projectAdminList:[
                {value: '1',label: '修改项目'},
                {value: '2',label: '查看日志'}
            ],
            projectAdminvalue:'',
            projectFlag:false,
            isNewProject:1,//1 新建  2修改
            operationProject : {}
        }
    },
    computed: {
        // 计算表格最大高度，确保分页控件可见
        tableMaxHeight() {
            // Header(60) + self-back(50) + padding(30) + topOperation(50) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 340px
            return window.innerHeight - 265;
        }
    },
    created(){
        this.getListEvent(1)
    },
    methods: {
        checkSelectable(row){//锁单的不可删除
            return row.del_enable==1
        },
        toFileAdmin(id){
            let routeData = this.$router.resolve({
                path: '/placeFile/'+id,
            })
            this.$winopen(routeData.href)
        },
        rmit_updateList(){//更新列表
            this.projectFlag = false
            this.getListEvent(this.page)
        },
        emit_closeToast(){//关闭弹框
            this.projectFlag = false
        },
        deleteProject(){//删除项目
            if(!this.multipleSelection || this.multipleSelection.length == 0){
                this.$message({
                    message: '未选择要删除的项目',
                    type: 'warning'
                })
                return
            }
            this.$confirm('确定要删除所选中项目吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    var arr = [];
                    this.multipleSelection.forEach((item)=>{
                        arr.push(item.id)
                    })
                    this.loading = true;
                    this.$axios.post(this.URL.BASEURL + this.URL.projectDel,{
                        ids: arr
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.getListEvent(1)
                        }else {
                            this.loading = false;
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {
            });
        },
        handleCurrentChange(val){
            this.getListEvent(val)
        },
        getListEvent(page,source){
            this.loading = true;
            this.page = page
            var page = page;
            var page_size = this.page_size
            if(source == 'export'){
                page = 1;
                page_size = 999;
                var moreLoading = this.$loading({
                    lock: true,
                    background: 'rgba(255, 2550, 255, 0.7)'
                });
            }
            var paramsData = {
                    page: page,
                    pagesize: page_size,
                }
            if(this.keyword){
                paramsData.title = this.keyword
            }
            if(this.timeMonth){
                paramsData.month = this.timeMonth + '-01'
            }
            this.$axios.get(this.URL.BASEURL + this.URL.projectIndex,{
                params:paramsData
            }).then((res) => {
                var res=res.data;
                if(source == 'export'){
                    moreLoading.close()
                }
                this.loading = false;
                if(res&& res.errno == 0){
                    if(source == 'export'){
                        this.exportToExcel(res.rst.data)
                    }else{
                        this.tableData = res.rst.data;
                        this.total = res.rst.pageInfo.total;
                    }
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                if(source == 'export'){
                    moreLoading.close()
                }
                this.loading = false
            })
        },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      toOrderList(data){
            var del_enable = data.del_enable == 1 ? 0 : 1
            let routeData = this.$router.resolve({
                path: '/orderList/'+data.id+'/'+del_enable,
            })
            this.$winopen(routeData.href)
      },
      exportToExcel(data) {
            var liveList = data;
            let jsonData = [];
            for(var i in liveList) {
                jsonData.push({
                'title':liveList[i].title?liveList[i].title:'',
                'advertiser_account':liveList[i].advertiser_account?liveList[i].advertiser_account:'',
                'advertiser_id':liveList[i].advertiser_id?liveList[i].advertiser_id:'',
                'company':liveList[i].company?liveList[i].company:'',
                'month':liveList[i].month?liveList[i].month + '\t':'',
                'sales_name':liveList[i].sales_name?liveList[i].sales_name:'',
                'handle_user':liveList[i].handle_user?liveList[i].handle_user:'',
                'customer_name':liveList[i].customer_name?liveList[i].customer_name:'',
                'platform_name':liveList[i].platform_name?liveList[i].platform_name:'',
                'media_name':liveList[i].media_name?liveList[i].media_name:'',
                'created_at':liveList[i].created_at?liveList[i].created_at + '\t':'',
                })
            }
            let th_arr = `项目名称,所属账户,账户ID,签约公司,所属月份,销售人员,经手人,客户全称,投放平台,媒体名称,创建时间\n`;
            //增加\t为了不让表格显示科学计数法或者其他格式
            for(let i = 0 ; i < jsonData.length ; i++ ){
                for(let item in jsonData[i]){
                    th_arr+=`${jsonData[i][item]},`;
                }
                th_arr+='\n';
            }
            //encodeURIComponent解决中文乱码
            let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(th_arr);
            //通过创建a标签实现
            let link = document.createElement("a");
            link.href = uri;
            //对下载的文件命名
            link.download =  "项目列表.csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
    watch:{
        projectFlag(){
            if(!this.projectFlag){
                this.projectAdminvalue=''
            }
        },
        timeMonth(){
            this.getListEvent(1)
        }
    }
}
</script>
<style lang="scss" scoped>
.containter{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    // display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: calc(100vh - 140px);
    .topOperation{
        padding: 16px;
        flex-shrink: 0;
        .left{
            float: left;
            button{
                width: 50px;
                height: 22px;
                border-radius: 2px;
                border: 1px solid #5B7BFE;
                background: transparent;
                color: #5B7BFE;
                font-size: 12px;
                margin-right: 14px;
                margin-top: 3px;
            }
        }
        .right{
            float: right;
        }
    }
    .listBox{
        border-top: 1px solid #E6E6EF;
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        .projectItemOperation{
            width: 85px;
            height: 28px;
            border-radius: 2px;
            border: 1px solid #5B7BFE;
            text-align: center;
            position: relative;
            display: inline-block;
            color: #5B7BFE;
            font-size: 13px;
            line-height: 28px;
            transform: scale(0.86);
            cursor: pointer;
            .selectProject{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
            }
        }
    }
    .paginationBox{
        flex-shrink: 0;
        margin: 15px;
        padding-bottom: 0;
    }
}


</style>


// WEBPACK FOOTER //
// src/components/disposeAdmin/project/index.vue